export default "__VITE_ASSET__DS0CSA10__"